import DateFnsUtils from '@date-io/date-fns'
import { MenuItem } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { prop, head } from '@soltalabs/ramda-extra'
import { Form, Field, Formik } from 'formik'
import moment from 'moment'
import React from 'react'
import * as Yup from 'yup'

import { StyledCircularProgress } from '../../common/styles'

import { redux } from './redux'
import {
  FormContainer,
  InputContainer,
  StyledTextField,
  AddButton,
  ScheduleDateButtonGroup,
  ScheduleDateButton,
  NameLabel,
} from './styles'

const AddJobSchema = Yup.object().shape({
  jobName: Yup.string().required('Name cannot be empty'),
  productId: Yup.string().required('Please select a product'),
})

const today = moment.utc().startOf('day')
const tomorrow = moment
  .utc()
  .add(1, 'days')
  .startOf('day')
const dayAfter = moment
  .utc()
  .add(2, 'days')
  .startOf('day')

const AddJobFormView = ({ address, productsList, onSubmit }) => (
  <FormContainer>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Formik
        initialValues={{
          jobName: '',
          scheduledAt: today,
          productId: prop('id', head(productsList)),
        }}
        validationSchema={AddJobSchema}
        onSubmit={onSubmit}
      >
        {() => (
          <Form>
            <InputContainer>
              <NameLabel>{address || <StyledCircularProgress />}</NameLabel>
              <Field
                type="text"
                name="jobName"
                label="Name"
                placeholder="Enter a name for the job"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                component={StyledTextField}
              />
              <Field
                type="text"
                name="productId"
                label="Product"
                select
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                component={StyledTextField}
              >
                {productsList.map(({ id, name, applicationRate }) => (
                  <MenuItem key={id} value={id}>
                    {`${name} ${applicationRate}`}
                  </MenuItem>
                ))}
              </Field>

              <Field name="scheduledAt">
                {({ field, form }) => {
                  const { value } = field
                  const { setFieldValue } = form

                  return (
                    <ScheduleDateButtonGroup>
                      <ScheduleDateButton
                        selected={value.isSame(today)}
                        onClick={() => setFieldValue('scheduledAt', today)}
                      >
                        Today
                      </ScheduleDateButton>
                      <ScheduleDateButton
                        selected={value.isSame(tomorrow)}
                        onClick={() => setFieldValue('scheduledAt', tomorrow)}
                      >
                        Tomorrow
                      </ScheduleDateButton>
                      <ScheduleDateButton
                        selected={value.isSame(dayAfter)}
                        onClick={() => setFieldValue('scheduledAt', dayAfter)}
                      >
                        Day After
                      </ScheduleDateButton>
                    </ScheduleDateButtonGroup>
                  )
                }}
              </Field>
              <AddButton variant="contained" type="submit">
                Add
              </AddButton>
            </InputContainer>
          </Form>
        )}
      </Formik>
    </MuiPickersUtilsProvider>
  </FormContainer>
)

const AddJobForm = redux(AddJobFormView)

export { AddJobForm }
